import { Expose } from "class-transformer";
import { IsBoolean, IsNumber, IsString } from "class-validator";

export class TemporaryRole {
  @Expose()
  @IsNumber()
  id!: number;
  @Expose()
  @IsNumber()
  recordStampId!: number;
  @Expose()
  @IsString()
  roleId!: string;
  @Expose()
  @IsString()
  roleName!: string;
  @Expose()
  @IsString()
  from!: string;
  @Expose()
  @IsString()
  to!: string;
  @Expose()
  @IsBoolean()
  isActivated!: boolean;
}
